/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_af7946c1',
  icon: 'icon_af7946c1',
  themeDarkAltColor: 'themeDarkAltColor_af7946c1',
  leftText: 'leftText_af7946c1',
  splitter: 'splitter_af7946c1',
  button: 'button_af7946c1',
  darkerBG: 'darkerBG_af7946c1',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_af7946c1{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_af7946c1{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_af7946c1{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_af7946c1{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_af7946c1{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_af7946c1.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_af7946c1:hover{background:initial}.darkerBG_af7946c1{background:#d0d0d0}"}]);
/* tslint:enable */